import { render, staticRenderFns } from "./UserGroupTable.vue?vue&type=template&id=88c80fa8&scoped=true&"
import script from "./UserGroupTable.vue?vue&type=script&lang=js&"
export * from "./UserGroupTable.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupTable.vue?vue&type=style&index=0&id=88c80fa8&lang=scss&scoped=true&"
import style1 from "./UserGroupTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c80fa8",
  null
  
)

export default component.exports